export default "__VITE_ASSET__PjElCpJ50M8sBJLd$C91mw__"